// src/components/DeepLinkHandler.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const DeepLinkHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isiOS = /iphone|ipad|ipod/i.test(userAgent);

    // Deep link for your app (e.g., myapp://)
    const appDeepLink = "myapp://example-path";

    // App store URLs
    const playStoreURL =
      "https://play.google.com/store/apps/details?id=com.elevated_iron&pli=1";
    const appStoreURL =
      "https://apps.apple.com/pk/app/elevated-iron/id6736553946";

    // Web fallback URL
    const webFallbackURL = "/web-fallback";

    // Try to open the app
    const openApp = () => {
      window.location.href = appDeepLink;
      // If the app isn't installed, redirect after a delay
      setTimeout(() => {
        if (isAndroid) {
          window.location.href = playStoreURL;
        } else if (isiOS) {
          window.location.href = appStoreURL;
        } else {
          navigate(webFallbackURL);
        }
      }, 1000); // Adjust timeout as needed
    };

    openApp();
  }, [navigate]);

  return <div>Redirecting...</div>;
};

export default DeepLinkHandler;
